export const CENTRE_IMAGE_VIEWED = 'Offline - Centre Image Viewed';
export const CENTRE_GET_DIRECTIONS = 'Offline - Get Directions Clicked';
export const CENTRE_DEMO_VIDEO_PLAYED = 'Offline - Demo Video Played';
export const CENTRE_DOWNLOAD_BROCHURE = 'Offline - Download Brochure';
export const CENTRE_BATCH_FILTER_CLICKED = 'Offline - Batch Filter Clicked';
export const CENTRE_GOAL_SELECTED = 'Offline - Goal Selected';
export const CENTRE_DROPDOWN_SELECTED = 'Offline - Centre Dropdown Clicked';
export const CENTRE_CITY_SELECTED = 'Checkout - City Selected';
export const OFFLINE_CENTRE_SOURCE = 'Centre Goal Page';
export const OFFLINE_LOCATION_PERMISSION_SELECTED =
  'Offline - Location Permission Selected';
export const OFFLINE_VISIT_THE_CENTRE = 'Offline - Visit the centre';

export const OFFLINE_VIST_GOAL_SELECTED = 'Offline Book Visit - Goal selected';

export const OFFLINE_VIST_CENTRE_SELECTED =
  'Offline Book Visit - Centre selected';

export const OFFLINE_VIST_SLOT_SELECTED = 'Offline Book Visit - Slot selected';

export const OFFLINE_VIST_BOOK_CLICKED = 'Offline Book Visit - Clicked';

export const OFFLINE_VIST_BOOK_SUCCESSFUL = 'Offline Book Visit - Successful';

export const OFFLINE_VIST_BOOK_SLOTS_SHOWN = 'Offline Book Visit - Slots shown';

export const OFFLINE_VIST_BOOK_CANCEL_CLICKED =
  'Offline Book Visit - Cancel clicked';

export const FOUND = 'Found';
export const NOT_FOUND = 'notFound';
